module.exports = __webpack_public_path__ + "img/undraw_Mobile_app_re_catg.fc87cb32.svg";